module.exports = __webpack_public_path__ + "static/media/NoDeskPhoto@2x.a8cdd218.png";